var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"pc-note__preview"},[_c('note-content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }